export enum CarbonScoreType {
  SupplierData = 'supplierData',
  ProxyData = 'proxyData',
  IndustryBenchmark = 'industryBenchmark',
}

export enum CarbonIntensityBasis {
  PerKg = 'perKg',
  PerLitre = 'perLitre',
}

export enum ProxyCarbonScoreConfidence {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export interface ResolvedCarbonScore {
  carbonIntensityKgCo2e: number | null;
  intensityBasis: CarbonIntensityBasis;
  carbonScoreKgCo2e: number | null;
  scoreType: CarbonScoreType;
  proxyCarbonScoreData: ProxyCarbonScoreData | null;
}

export interface ProxyCarbonScoreData {
  confidence: ProxyCarbonScoreConfidence;
  gpcClass: string;
  gpcBrick: string | null;
  gpcClassification: string;
  sourceDbName: string;
  sourceDbId: string;
  lifecycleStage: string;
  originRegion: string;
  applicableRegion: string;
  productionSystem: string;
  funcUnit: string;
  factorType: string;
  dataQualityScore: number;
}
